export const $green = "#00cec5";
export const companies = {
    LPG: 1,
    LPV: 3,
    LPS: 4
}